import React from 'react';
import { Create } from 'react-admin';
import SubsectorForm from '../SubsectorForm';

function SubsectorCreate(props) {
  return (
    <Create {...props}>
      <SubsectorForm redirect="list" />
    </Create>
  );
}

export default SubsectorCreate;
